import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Switch from 'flarum/common/components/Switch';
import StoryBar from './components/StoryBar';
import StoryBadge from './components/StoryBadge';
import StoryLikedNotification from './components/StoryLikedNotification';
import StoryMentionedNotification from './components/StoryMentionedNotification';
import StoryRepliedNotification from './components/StoryRepliedNotification';
import StoryViewer from './components/StoryViewer';
import StoryCreator from './components/StoryCreator';
import applyAvatarRings from './applyAvatarRings';
import store from './storyStore';
import Story from './models/Story';

app.initializers.add('happydigital-stories', () => {
  // Register modals so Flarum can manage them
  app.storyViewer  = null;
  app.storyCreator = null;

  // One shared source of truth about who currently has a story.
  app.storyStore = store;

  // Inject the StoryBar into IndexPage, just below the hero section
  override(IndexPage.prototype, 'hero', function (original) {
    const hero = original.call(this);
    return (
      <div className="HappyStories-heroWrapper">
        {hero}
        <StoryBar />
      </div>
    );
  });

  // Avatar rings in the discussion list and on profiles.
  applyAvatarRings();

  // Inside a post the story is surfaced as a header badge instead — the
  // avatar there already carries a group border and an attached badge.
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const user = this.attrs.post && this.attrs.post.user();

    if (!user || !store.hasStory(user.id())) return;

    // Admin switch, then the author's own preference.
    if (!store.showsBadge(user.id())) return;

    items.add('happydigital-story', StoryBadge.component({ user }), -10);
  });

  // Let each user keep their story badge off their own posts.
  extend(SettingsPage.prototype, 'privacyItems', function (items) {
    // Nothing to decide when the admin has turned the badge off entirely.
    if (!app.forum.attribute('happydigital-stories.showBadgeOnPosts')) return;

    items.add(
      'happydigital-story-badge',
      Switch.component(
        {
          state: this.user.preferences().happydigitalShowStoryOnPosts !== false,
          loading: this.storyBadgeLoading,
          onchange: (value) => {
            this.storyBadgeLoading = true;

            this.user
              .savePreferences({ happydigitalShowStoryOnPosts: value })
              .then(() => {
                this.storyBadgeLoading = false;
                m.redraw();
              })
              .catch(() => {
                this.storyBadgeLoading = false;
                m.redraw();
              });
          },
        },
        app.translator.trans('happydigital-stories.forum.settings.show_badge_label')
      )
    );
  });

  // The notification subject arrives as this type; without a model the store
  // can't resolve it and the notification list renders empty.
  app.store.models['happydigital-stories'] = Story;

  // Notification types, matching the blueprints registered in extend.php.
  app.notificationComponents.storyLiked     = StoryLikedNotification;
  app.notificationComponents.storyMentioned = StoryMentionedNotification;
  app.notificationComponents.storyReplied   = StoryRepliedNotification;

  // The store seeds itself lazily on first use. Reading app.forum here would
  // be too early — it isn't populated while initializers run.
});
